import script from "./GameCity.vue?vue&type=script&setup=true&lang=js"
export * from "./GameCity.vue?vue&type=script&setup=true&lang=js"

import "./GameCity.vue?vue&type=style&index=0&id=2617e1e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2617e1e4"]])

export default __exports__